import { dbAnotadorInstance } from "../database/db";
import { Entity } from "../objects/Entity.interface";

export const createNewEntity = ():Entity => {
    var _newEntity:Entity = {
        id: 0,
        Entity: "Mobility",
        Code: "e_1",
        Color: "#d0d176",
        Fields: 3,
        FieldList: [],
        selected: true,
        projectId: 0
    };
  
    return _newEntity;
}

export class EntitiesService{
    constructor (){}

    getList(id:number){
        const result = dbAnotadorInstance.entities.where({projectId: id}).toArray();

        return result;
    }

    getEntityById(entityId:number){
        const result = dbAnotadorInstance.entities.where({id:entityId}).toArray();
        return result;
    }

    update(entity: Entity){
        const result = dbAnotadorInstance.entities.update(entity.id!, 
            {
            Entity: entity.Entity,
            Color: entity.Color,
            Fields: entity.Fields,
            FieldList: entity.FieldList,
            selected: entity.selected
        });
        return result;
    }

    add(entity:Entity){
        const result = dbAnotadorInstance.entities.add(entity);
        return result;
    }

    async addSet(entities: Entity[]):Promise<number>{
        return await dbAnotadorInstance.entities.bulkAdd(entities).then(res => {return res;})
    }
    delete(key:number)
    {
        const result = dbAnotadorInstance.entities.delete(key);
        return result;
    }
}